import styled, { css } from 'styled-components';

import ButtonComponent from 'components/Button/Button';
import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';

export const SectionComponentWrapper = styled.div`
  grid-column: 2 / -2;

  h2 {
    ${({ theme: { locale } }) => setTypography('heading3', locale)};
    margin-bottom: 24px;
  }

  h3,
  h4 {
    ${({ theme: { locale } }) => setTypography('heading4', locale)};
    margin-bottom: 24px;
  }

  ${({ theme: { locale } }) =>
    mediaDesktop(
      css`
        grid-column: 7 / -4;

        &:last-child {
          grid-column: 2 / 6;
        }

        h2 {
          ${setTypography('heading3', locale)};
          margin-bottom: 32px;
        }

        h3,
        h4 {
          ${setTypography('heading4', locale)};
          margin-bottom: 32px;
        }
      `
    )}
`;

export const Button = styled(ButtonComponent)`
  margin-top: 40px;

  ${mediaDesktop(css`
    margin-top: 48px;
  `)}
`;
